import React, { forwardRef, ComponentClass } from 'react';
import { ClassNamePropsWithChildren } from 'components/ozone-component';

export type TitleProps = ClassNamePropsWithChildren;

type TitleType = ComponentClass<TitleProps>;

export const Title: TitleType = forwardRef((props: TitleProps, ref) => {
  const { children, className, ...rest } = props;

  return (
    <h5 ref={ref as any} className={className} {...rest}>
      {props.children}
    </h5>
  );
}) as unknown as TitleType;
